exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3s0he{margin-left:250px;margin-top:50px;position:fixed;bottom:0;padding:15px;background:#e7e7e7;width:calc(100% - 250px);text-align:center}", ""]);

// exports
exports.locals = {
	"footerContainer": "_3s0he"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/siteadmin/AdminFooter/AdminFooter.css
// module id = 2593
// module chunks = 15